/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Advanced_OptionsInputs */

const en_dialog_advanced_options = /** @type {(inputs: Dialog_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced options`)
};

const es_dialog_advanced_options = /** @type {(inputs: Dialog_Advanced_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones avanzadas`)
};

/**
* | output |
* | --- |
* | "Advanced options" |
*
* @param {Dialog_Advanced_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_advanced_options = /** @type {((inputs?: Dialog_Advanced_OptionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Advanced_OptionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_advanced_options(inputs)
	return en_dialog_advanced_options(inputs)
});